function NRSBOMIcon({ height = '20', width = '20', color = 'currentColor' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M10 1.66797L5.41667 9.16797H14.5833L10 1.66797ZM10 4.86797L11.6083 7.5013H8.38333L10 4.86797ZM14.5833 10.8346C12.5083 10.8346 10.8333 12.5096 10.8333 14.5846C10.8333 16.6596 12.5083 18.3346 14.5833 18.3346C16.6583 18.3346 18.3333 16.6596 18.3333 14.5846C18.3333 12.5096 16.6583 10.8346 14.5833 10.8346ZM14.5833 16.668C13.4333 16.668 12.5 15.7346 12.5 14.5846C12.5 13.4346 13.4333 12.5013 14.5833 12.5013C15.7333 12.5013 16.6667 13.4346 16.6667 14.5846C16.6667 15.7346 15.7333 16.668 14.5833 16.668ZM2.5 17.918H9.16667V11.2513H2.5V17.918ZM4.16667 12.918H7.5V16.2513H4.16667V12.918Z"
        fill={color}
      />
    </svg>
  );
}
export default NRSBOMIcon;
